




import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IPortalUser } from "../../../models/interfaces/authentication/portal-user.model.interface";

const UserModule = namespace("userManagementModule");

@Component({})
export default class AuthoriseUserButton extends Vue {
    @UserModule.Getter public user;
    @UserModule.Action public authorise;

    @Provide() public userModel: IPortalUser;

    public created() {
        this.setCurrentUser(this.user);
    }

    get getUser(): IPortalUser | null {
        return this.user;
    }

    @Watch("getUser")
    public onUserChanged(val: IPortalUser | null, oldVal: IPortalUser | null) {
        this.setCurrentUser(val);
    }

    public setCurrentUser(val: IPortalUser | null) {
        if (val) {
            this.userModel = val;
        }
    }

    public authoriseUser() {
        if (this.getUser) {
            this.authorise(this.getUser.id);
        }
    }
}
